export class showHideOtherField {
  attach() {
    $(function () {
      $('#id_school')
        .off('change.id_school')
        .on('change.id_school', function () {
          var school = $(this).val()
          if (school === '') {
            $('#id_school_other').closest('[data-name="school_other"]').show()
          } else {
            $('#id_school_other').closest('[data-name="school_other"]').hide()
          } // if
        })
        .trigger('change.id_school')
    })
  }
} // ready
